import { WhatsappConversationModel } from "@jugl-web/rest-api/integrations/models/WhatsappConversation";
import { InstagramConversationModel } from "@jugl-web/rest-api/integrations/models/InstagramConversation";
import { WebChatBotConversationModel } from "@jugl-web/rest-api/integrations/models/WebChatBotConversation";
import { WhatsappMessageModel } from "@jugl-web/rest-api";
import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";
import { WebChatBotMessageModel } from "@jugl-web/rest-api/integrations/models/WebChatBotMessage";
import { TwilioMessageModel } from "@jugl-web/rest-api/integrations/models/TwilioMessage";

export function isWhatsappConversation(
  conversation:
    | WhatsappConversationModel
    | InstagramConversationModel
    | WebChatBotConversationModel
): conversation is WhatsappConversationModel {
  return "attended_by" in conversation;
}

export function isInstagramConversation(
  conversation:
    | WhatsappConversationModel
    | InstagramConversationModel
    | WebChatBotConversationModel
): conversation is InstagramConversationModel {
  return "business_id" in conversation;
}

export function isWebConversation(
  conversation:
    | WhatsappConversationModel
    | InstagramConversationModel
    | WebChatBotConversationModel
): conversation is WebChatBotConversationModel {
  return !("attended_by" in conversation) && !("business_id" in conversation);
}

export function isWhatsappMessage(
  message: WhatsappMessageModel | InstagramMessageModel | WebChatBotMessageModel
): message is WhatsappMessageModel {
  return "auto_response" in message;
}

export function isInstagramMessage(
  message: WhatsappMessageModel | InstagramMessageModel | WebChatBotMessageModel
): message is InstagramMessageModel {
  return "business_id" in message;
}

export function isWebMessage(
  message:
    | WhatsappMessageModel
    | InstagramMessageModel
    | WebChatBotMessageModel
    | TwilioMessageModel
): message is WebChatBotMessageModel | TwilioMessageModel {
  return !("auto_response" in message) && !("business_id" in message);
}
